export default __webpack_public_path__ + "static/media/bp-house.7dfb67fc.gif";